import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import authentication from './authentication';
import user from './user';

Vue.use(Vuex);

const authenticationValuesStorageKey = 'ilt_authentication';

const vuexLocal = new VuexPersistence({
  key: authenticationValuesStorageKey,
  storage: window.localStorage,
  modules: ['auth', 'user'],
  reducer: (state) => ({
    authentication: state.authentication,
    user: state.user,
  }),
});

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    authentication,
    user,
  },
  plugins: [vuexLocal.plugin],
});

export const tokensUpdateChannel = new BroadcastChannel('auth-tokens-update');


tokensUpdateChannel.onmessage = (event) => {

  console.log("received auth tokens broadcast message", event.data);

  const {accessToken: receivedAccessToken, refreshToken: receivedRefreshToken, idToken: receivedIdToken} = event.data;

  const accessTokenStoredInThisContext = store.getters['authentication/getAccessToken'];

  // If we were not logged in and now we are, or the other way around, we refresh the page also
  if (
    (accessTokenStoredInThisContext && !receivedAccessToken) ||
    (!accessTokenStoredInThisContext && receivedAccessToken)
  ) {
    return window.location.reload();
  }

  // If the tokens just updated, we store them in this tab also
  store.commit('authentication/changeAccessToken', receivedAccessToken);
  store.commit('authentication/changeRefreshToken', receivedRefreshToken);
  store.commit('authentication/changeIdToken', receivedIdToken);
};

export default store;
